<template>
  <!-- 客服服务 -->
  <div class="customer-contain">
    <img class="qrcode"
         :src="qrcode" />
    <div class="customer-box flex bgColor1">
      <div class="icon icon1"></div>
      <div class="title color1">{{ $t('CustomerService.CustomerService.customAdvisor') }}</div>
    </div>
    <div class="customer-box flex bgColor2"
         @click="customerClick">
      <div class="icon icon2 cursor"></div>
      <div class="title cursor color2">{{ $t('CustomerService.CustomerService.onlineService') }}</div>
    </div>
  </div>
</template>
<script setup lang="ts">
import qrcode from "./assets/qrcode.png"
import { useChatWoot } from "@huntersofbook/chatwoot-vue"
const { toggle, setLabel } = useChatWoot()

const customerClick = () => {
  toggle("open")
  setLabel("name")
}
</script>

<style scoped lang="less">
.customer-contain {
  position: fixed;
  bottom: 10%;
  right: 1%;
  z-index: 999;
  text-align: center;
  width: 220px;
  height: 333px;
  background: #ffffff;
  box-shadow: 0px 0px 46px 0px rgba(0, 0, 0, 0.12);

  .customer-box {
    width: 220px;
    height: 60px;

    .icon {
      margin-right: 10px;
      height: 24px;
      width: 24px;
    }

    .icon1 {
      background: url("./assets/ic-mentor.png") no-repeat;
      background-size: cover !important;
    }

    .icon2 {
      background: url("./assets/ic-customer.png") no-repeat;
      background-size: cover !important;
    }

    .title {
      height: 60px;
      font-size: 18px;
      font-family: 'Microsoft YaHei';
      line-height: 60px;
    }

    .color1 {
      color: #111;
    }

    .color2 {
      color: #fff;
    }

    .cursor {
      cursor: pointer;
    }
  }

  .bgColor1 {
    background: #fff;
  }

  .bgColor2 {
    background: #111111;
  }

  .qrcode {
    width: 220px;
    height: 220px;
    padding: 15px 15px 0 15px;
  }
}

.flex {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.popover-contain {
  width: 150px;

  .borderRadius {
    border-radius: 20px;
  }

  img {
    width: 120px;
    height: 120px;
    display: inline-block;
  }

  .popover-box {
    margin: 5px 0 20px;
    font-size: 13px;
  }
}
</style>
